import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-employee-delete-modal',
  templateUrl: './employee-delete-modal.component.html',
  styleUrls: ['./employee-delete-modal.component.scss']
})
export class EmployeeDeleteModalComponent {
  confirmText = '';

  constructor(
    public dialogRef: MatDialogRef<EmployeeDeleteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { employeeName: string; companyName: string }
  ) {}

  confirm() {
    this.dialogRef.close('confirm');
  }
}
